module.exports = __webpack_public_path__ + "static/media/vegan.b9fa2636.png";